import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import "moment-timezone";
import { FaChartBar } from "react-icons/fa";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { months } from "../utils/rawData/dateValues";
import { ResponsivePie } from '@nivo/pie';
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import Tooltip from "../components/ui/ToolTip";


function EstadisticasTrabajador() {

  const user = useSelector((state) => state.auth.user);
  
  const [isLoading, setIsLoading] = useState(false)

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const [trabajadoresList, setTrabajadoresList] = useState([])

  const [record, setRecord] = useState([]);
  const [payments, setPayments] = useState([])

  const [amountPayments, setAmountPayments] = useState(0)
  const [payedPayments, setPayedPayments] = useState([])
  const [pendingPayments, setPendingPayments] = useState([])
  const [advancePayments, setAdvancePayments] = useState([])

  const [incidences, setIncidences] = useState([]);

  const [incidenciasLeve, setIncidenciasLeve] = useState([])
  const [incidenciasModerada, setIncidenciasModerada] = useState([])
  const [incidenciasGrave, setIncidenciasGrave] = useState([])
  const [incidenciasMuyGrave, setIncidenciasMuyGrave] = useState([])
  const [totalIncidencias, setTotalIncidencias] = useState(0)

  const [selectedWorker, setSelectedWorker] = useState("")

  const hoursWorked = record.reduce((acc, worker) => acc + worker.totalWorkTime, 0)
  const hoursDelay = record.reduce((acc, worker) => acc + worker.totalTardanza, 0)
  const hoursExtra = record.reduce((acc, worker) => acc + worker.totalExtra, 0)
  
  const getData = async () => {
    try {
      setIsLoading(true)

      let url = `${BACKEND}/api/metaDataUsers/getWorkersData?month=${month}&year=${year}`

      if (selectedWorker) {
        url += `&idWorker=${selectedWorker}`
      }
      
      const response = await axios.get(url)

      setRecord(response.data.workers)
    } catch (error) {
      toast.error("Error obteniendo la data: " + error)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchPayment = async () => {
    try {
      let url = `${BACKEND}/api/pagosTrabajadores?limit=0&where[month][equals]=${month}&where[year][equals]=${year}`

      if (selectedWorker) {
        url += `&where[worker][equals]=${selectedWorker}`
      }

      const response = await axios.get(url);
      setAmountPayments(response.data.docs.reduce((acc, payment) => acc + payment.amount, 0))
      setPayedPayments(response.data.docs.filter(p => p.status === "Pagado"))
      setPendingPayments(response.data.docs.filter(p => p.status === "Pendiente"))
      setAdvancePayments(response.data.docs.filter(p => p.status === "Adelanto"))
      setPayments(response.data.docs);
    } catch (error) {
      toast.error("Error obteniendo los registros: " + error);
    }
  };

  const getIncidences = async () => {
    try {
      let url = `${BACKEND}/api/incidencias?limit=0&where[month][equals]=${month}&where[year][equals]=${year}`

      if (selectedWorker) {
        url += `&where[trabajador][equals]=${selectedWorker}`
      }

      const response = await axios.get(url);

      setIncidenciasLeve(response.data.docs.filter(i => i.gravedad === "Leve"))
      setIncidenciasModerada(response.data.docs.filter(i => i.gravedad === "Moderada"))
      setIncidenciasGrave(response.data.docs.filter(i => i.gravedad === "Grave"))
      setIncidenciasMuyGrave(response.data.docs.filter(i => i.gravedad === "Muy grave"))

      setTotalIncidencias(response.data.docs.length)

      setIncidences(response.data.docs)
    } catch (error) {
      toast.error("Error obteniendo las incidencias: " + error)
    }
  }

  const getWorkers = async () => {
    const response = await axios.get(`${BACKEND}/api/metaDataUsers/getWorkersData`)
    setTrabajadoresList(response.data.workers)
  }

  useEffect(() => {
    getData()
    fetchPayment()
    getIncidences()
    getWorkers()
  }, [])

  useEffect(() => {
    getData()
    fetchPayment()
    getIncidences()
  }, [month, year, selectedWorker])

  const paymentStatusColor = {
    "Pagado": "text-green-500",
    "Pendiente": "text-yellow-500",
    "Adelanto": "text-blue-500"
  }

  return (
    <div className="w-full flex flex-col h-screen">
      
      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="flex flex-row justify-start">
            <div className="flex items-center gap-4 p-4">
              <FaChartBar className="text-gray-700 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-700">Estadísticas de trabajadores</h2>
            </div>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Trabajador:</span>
              <select
                id="filtroFechaInicio"
                name="filtroFechaInicio"
                value={selectedWorker}
                onChange={(e) => setSelectedWorker(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                {trabajadoresList.map((worker) => (
                  <option
                    key={worker.id}
                    value={worker.id}
                  >
                    {worker.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Mes:</span>
              <select
                id="filtroFechaInicio"
                name="filtroFechaInicio"
                value={month}
                onChange={(e) => setMonth(Number(e.target.value))}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                {months.map((monthOption) => (
                  <option
                    key={monthOption.value}
                    value={monthOption.value}
                  >
                    {monthOption.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Año:</span>
              <select
                type="date"
                id="filtroFechaFin"
                name="filtroFechaFin"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
              </select>
            </div>
          </div>

        </div>
      </div>

      {/* Body */}
      <div className="flex flex-row w-full h-full">
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <div className="flex flex-col md:flex-row w-full h-full gap-4 p-4">

            {/* Gráficos */}
            <div className="flex flex-col w-full md:w-1/2 gap-4">

              <div className="flex flex-col md:flex-row w-full gap-4">

                {/* Gráfico de Registros */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Tardanzas y minutos extra</h3>
                  <span className="text-xs text-gray-500">Horas trabajadas: {hoursWorked}</span>
                  {hoursWorked !== "0h 0m" ? (
                    <ResponsivePie
                      data={[
                        {
                          id: 'Minutos de Tardanza',
                          label: 'Minutos de tardanza',
                          //value: record[0].workTimeByDay.filter(r => r.tardanza > 0).length,
                          value: hoursDelay,
                          color: '#f32b2b'
                        },
                        {
                          id: 'Minutos extra',
                          label: 'Minutos extra',
                          //value: record.filter(r => r.status === 'late').length,
                          value: hoursExtra,
                          color: '#369ff4'
                        }
                      ]}
                      margin={{ top: 40, right: 60, bottom: 60, left: 60 }}
                      innerRadius={0.5}
                      padAngle={0.7}
                      cornerRadius={3}
                      activeOuterRadiusOffset={8}
                      colors={d => d.data.color}
                      borderWidth={1}
                      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                      enableArcLinkLabels={false}
                      arcLinkLabelsSkipAngle={5}
                      arcLinkLabelsTextColor="#333333"
                      arcLabelsSkipAngle={5}
                      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                    />
                  ) : (
                    <NoDataScreen text="No hay registros" />
                  )}
                </div>

                {/* Gráfico de Incidencias */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Incidencias</h3>
                  <span className="text-xs text-gray-500">Total de incidencias: {totalIncidencias}</span>
                  {totalIncidencias > 0 ? (
                    <ResponsivePie
                      data={[
                        {
                          id: 'Leve',
                          label: 'Leve',
                          value: incidenciasLeve.length,
                          color: '#FFD700'
                        },
                        {
                          id: 'Moderada',
                          label: 'Moderada',
                          value: incidenciasModerada.length,
                          color: '#FFA500'
                        },
                        {
                          id: 'Grave',
                          label: 'Grave',
                          value: incidenciasGrave.length,
                          color: '#FF0000'
                        },
                        {
                          id: 'Muy grave',
                          label: 'Muy grave',
                          value: incidenciasMuyGrave.length,
                          color: '#8B0000'
                        }
                      ]}
                      margin={{ top: 40, right: 60, bottom: 60, left: 60 }}
                      innerRadius={0.5}
                      padAngle={0.7}
                      cornerRadius={3}
                      activeOuterRadiusOffset={8}
                      colors={d => d.data.color}
                      borderWidth={1}
                      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                      enableArcLinkLabels={false}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                    />
                  ) : (
                    <NoDataScreen text="No hay incidencias" />
                  )}
                </div>

              </div>

              <div className="flex flex-col md:flex-row w-full gap-4">

                {/* Gráfico de Asistencias */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Asistencias</h3>
                  <span className="text-xs text-gray-500"> Asistencias en el mes: {record.reduce((acc, r) => acc + r.workTimeByDay.filter(r => r.tardanza === 0).length, 0)}</span>
                  {record.reduce((acc, r) => acc + r.workTimeByDay.filter(r => r.tardanza === 0).length, 0) !== 0 ? (
                    <ResponsivePie
                      data={[
                        {
                          id: 'Asistencias',
                          label: 'Asistencias',
                          value: record.reduce((acc, r) => acc + r.workTimeByDay.filter(r => r.tardanza === 0).length, 0),
                          color: '#f32b2b'
                        },
                        {
                          id: 'Tardanzas',
                          label: 'Tardanzas',
                          value: record.reduce((acc, r) => acc + r.workTimeByDay.filter(r => r.tardanza > 0).length, 0),
                          color: '#369ff4'
                        }
                      ]}
                      margin={{ top: 40, right: 60, bottom: 60, left: 60 }}
                      innerRadius={0.5}
                      padAngle={0.7}
                      cornerRadius={3}
                      activeOuterRadiusOffset={8}
                      colors={d => d.data.color}
                      borderWidth={1}
                      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                      enableArcLinkLabels={false}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                    />
                  ) : (
                    <NoDataScreen text="No hay registros" />
                  )}
                </div>

                {/* Tabla de Incidencias */}
                <div className="w-full md:w-1/2 bg-white h-[400px] rounded-md shadow-md p-4 border border-gray-200">
                  <h3 className="text-xs font-semibold">Incidencias</h3>
                  <span className="text-xs text-gray-500">Total descuentos: S/. {incidences.reduce((acc, i) => acc + (i.descuento ? i.descuento : 0), 0)}</span>
                  {incidences.length > 0 ? (
                    <div className="flex flex-col gap-2 flex-grow h-[calc(100%-3rem)] overflow-y-auto">
                      {incidences.map((i, index) => (
                        <div key={index} className="flex flex-col bg-white rounded-lg shadow-sm p-3 hover:bg-gray-50 border border-gray-100">
                          <div className="flex justify-between items-center mb-1">
                            <div className="flex items-center gap-2">
                              <img 
                                src={i.trabajador?.foto?.url || 'https://via.placeholder.com/30'} 
                                alt={i.trabajador?.name} 
                                className="w-6 h-6 rounded-full object-cover"
                              />
                              <div className="flex items-center gap-1 mb-1">
                                <span className="text-[10px] font-medium text-gray-800">{i.trabajador?.name || 'No especificado'}</span>
                              </div>
                            </div>
                            <span className={`px-2 py-1 text-[10px] font-semibold rounded-full 
                              ${i.gravedad === 'Leve' ? 'bg-green-100 text-green-800' : 
                                i.gravedad === 'Moderada' ? 'bg-yellow-100 text-yellow-800' :
                                i.gravedad === 'Grave' ? 'bg-orange-100 text-orange-800' :
                                'bg-gray-100 text-gray-800'}`}>
                              {i.gravedad}
                            </span>
                          </div>
                          <h4 className="text-[10px] font-medium text-gray-800">{i.titulo}</h4>

                          <div>
                            <Tooltip content={i.comentario}>
                              <span className="text-[10px] text-gray-500 hover:cursor-pointer hover:underline">Detalles</span>
                            </Tooltip>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-[10px] text-gray-500">
                              {moment(i.fecha).format('DD/MM/YYYY')}
                            </span>
                            <span className="text-[10px] text-red-600">
                              Descuento: S/. {i.descuento || 0}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <NoDataScreen text="No hay incidencias" />
                  )}
                </div>

              </div>
            
            </div>
            
            {/* Información de Pago */}
            <div className="w-full md:w-1/2">
              <div className="flex flex-col h-full w-full rounded-md shadow-md p-4 gap-4 border border-gray-200">

                <div className="grid grid-cols-3 gap-4">
                  <div className="p-4 bg-gray-50 rounded-lg"> 
                    <p className="text-xs text-gray-600">Pagados: <span className="text-gray-800 font-bold">{payedPayments?.length}</span></p>
                    <p className={`text-sm font-bold ${paymentStatusColor["Pagado"]}`}>S/. {payedPayments?.reduce((acc, p) => acc + p.amount, 0) || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Pendiente: <span className="text-gray-800 font-bold">{pendingPayments?.length}</span></p>
                    <p className={`text-sm font-bold ${paymentStatusColor["Pendiente"]}`}>S/. {pendingPayments?.reduce((acc, p) => acc + p.amount, 0) || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Adelanto: <span className="text-gray-800 font-bold">{advancePayments?.length}</span></p>
                    <p className={`text-sm font-bold ${paymentStatusColor["Adelanto"]}`}>S/. {advancePayments?.reduce((acc, p) => acc + p.amount, 0) || 0}</p>
                  </div>
                </div>

                {/* Resumen */}
                <div className="grid grid-cols-2 gap-4">
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Monto total</p>
                    <p className="text-sm font-bold text-gray-800">S/. {amountPayments || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Asistencias marcadas</p>
                    <p className="text-sm font-bold text-gray-800">{record.reduce((acc, r) => acc + r.workTimeByDay.length, 0) || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Incidencias</p>
                    <p className="text-sm font-bold text-red-500">{incidences.length || 0}</p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-600">Descuentos</p>
                    <p className="text-sm font-bold text-gray-800">
                      S/. {incidences.reduce((acc, i) => acc + (i.descuento || 0), 0) || 0}
                    </p>
                  </div>
                </div>

                {/* Contenedor de Imágenes */}
                <div className="flex w-full justify-center items-center rounded-md p-4">
                  <div className="w-full max-w-7xl mx-auto">
                    <div className="flex justify-center gap-4 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                      {payments?.filter(p => p.status === "Pagado" && p.images?.length > 0).map((payment, paymentIndex) => (
                        payment.images.map((image, imageIndex) => (
                          <div key={`${paymentIndex}-${imageIndex}`} className="flex-shrink-0">
                            <img
                              src={image.url}
                              alt={`Pago ${paymentIndex + 1} - Imagen ${imageIndex + 1}`}
                              className="w-[300px] h-[400px] object-contain rounded-lg shadow-md"
                            />
                          </div>
                        ))
                      ))}
                      {(!payments?.some(p => p.status === "Pagado" && p.images?.length > 0)) && (
                        <NoDataScreen text="No hay imágenes de pagos" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        )}
      </div>

    </div>
  );
}

export default EstadisticasTrabajador;
